import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as productRoutes } from './products/routes';
import { routes as dealRoutes } from './deals/routes';
import { routes as taskRoutes } from './tasks/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as painelRoutes } from './dashboard/routes';
import { routes as liveRoutes } from './live/routes';
import { routes as supportRoutes } from './support/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import scheduledMessagesRoutes from './scheduledMessages/scheduledMessages.routes';
import audiencesRoutes from './audiences/audiences.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import McpAuthorize from './mcpAuthorize/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...painelRoutes,
        ...conversation.routes,
        ...liveRoutes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...productRoutes,
        ...dealRoutes,
        ...taskRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...supportRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...scheduledMessagesRoutes.routes,
        ...audiencesRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      // Nunca '/auth...': o Rails serve o pacote de login (v3app) para caminhos com '/auth'
      path: frontendURL('mcp/consent'),
      name: 'mcp_authorize',
      component: McpAuthorize,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
